export enum EWeather {
    ALL = 'all',
    GOOD_ONLY = 'good_only',
}

export const HELMET_BUYER_GUIDE_URL_DATA_ATTRIBUTE = 'data-hbg-url';
